export default __webpack_public_path__ + "static/media/ss.f6aa2764.svg";